import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Styles/WaitingPage.css';

const WaitingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check for session data every 2 seconds
    const checkSession = setInterval(() => {
      const currentOrder = sessionStorage.getItem('currentOrder');
      const orderSession = sessionStorage.getItem('orderSession');
      const orderSessionId = sessionStorage.getItem('orderSessionId');
      
      // If all session data is cleared, redirect to home
      if (!currentOrder && !orderSession && !orderSessionId) {
        clearInterval(checkSession);
        navigate('/');
      }
    }, 2000);

    // Cleanup interval on component unmount
    return () => {
      clearInterval(checkSession);
    };
  }, [navigate]);

  // Prevent navigation by disabling browser back button and other navigation
  useEffect(() => {
    const handlePopState = (event) => {
      // Prevent going back
      window.history.pushState(null, '', window.location.pathname);
    };

    // Push current state to prevent back navigation
    window.history.pushState(null, '', window.location.pathname);
    window.addEventListener('popstate', handlePopState);

    // Cleanup
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return (
    <div className="waiting-container">
      <div className="waiting-card">
        {/* Loading Animation */}
        <div className="loading-spinner" />
        
        <h1 className="waiting-title">
          Order Processing
        </h1>
        
        <p className="waiting-message">
          Your order has been sent to the kitchen. Please wait while we prepare your meal.
        </p>
        
        {/* Kitchen animation */}
        <div className="kitchen-animation">
          <span className="kitchen-icon">👨‍🍳</span>
          <span className="kitchen-icon">🍳</span>
          <span className="kitchen-icon">🍽️</span>
        </div>
        
        <div className="waiting-subtitle">
          You will be redirected automatically when ready.
        </div>
        
        {/* Progress bar */}
        <div className="progress-container">
          <div className="progress-bar">
            <div className="progress-fill" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WaitingPage;